import React from "react";
import Guestbook from "../components/Letter/Guestbook";

const Letter = () => {
  return (
    <>
      <Guestbook />
    </>
  );
};

export default Letter;
